// extracted by mini-css-extract-plugin
export default {"ctaBtn":"PageHeadingWithCTA_ctaBtn__RcQT3","root":"PageHeadingWithCTA_root__olmyk"};